import { Pipe, PipeTransform } from '@angular/core';
import { PeopleService } from '../../shared/services';
import { Person } from '../../shared/models';

@Pipe({
    name: 'personName',
    standalone: false
})
export class PersonNamePipe implements PipeTransform {
  public people: Person[] = [];

  constructor(private service: PeopleService) {
    this.service.getPeople().subscribe((data) => {
      this.people = data;
    });
  }

  transform(id: string): any {
    const person = this.people.find((p) => p.id === id);
    return person ? person.name : '';
  }
}
